import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

// styles
import styles from "./styles.module.scss";

// components
// import Navbar from "src/components/common/Navbar/Navbar";
import Footer from "src/components/Footer/Footer";
import Hero from "../Hero/Hero";
import BlogList from "../BlogList/BlogList";

// mockup
import mockup from "src/utils/data";

// api
import { getBlogList } from "../api";

const Content = () => {
  const [blogList, setBlogList] = useState(mockup.empty_3);

  useEffect(() => {
    getBlogList()
      .then((res) => {
        if (res.data.Status) {
          setBlogList(res.data.Results);
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  }, []);

  return (
    <div className={styles.blog__content}>
      {/* <Navbar /> */}
      <Hero />
      <BlogList blogList={blogList} />
      <Footer />
    </div>
  );
};

export default Content;
